import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=7a2c7c8a"
import script from "./UserAdd.vue?vue&type=script&lang=js"
export * from "./UserAdd.vue?vue&type=script&lang=js"
import style0 from "./UserAdd.vue?vue&type=style&index=0&id=7a2c7c8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports